import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import GlobalContext from '../../context/GlobalContext'
import { Title, Section, Box, ButtonIcon } from '../../components/Core'
import bgFooter from '../../assets/image/png/subscribe-pattern.png'

const SectionStyled = styled(Section)`
    &.pattern::before {
        position: absolute;
        bottom: -150px;
        content: '';
        width: 120%;
        height: 150%;
        background: url(${bgFooter}) bottom center no-repeat;
        background-size: cover;
        z-index: -1;
    }
`

const Contact = ({ pattern = true }) => {
    const gContext = useContext(GlobalContext)

    return (
        <>
            {/* <!-- Hero Area --> */}
            <SectionStyled
                className={`position-relative ${pattern ? 'pattern' : ''}`}
            >
                <Container>
                    <Row className="justify-content-center align-items-center">
                        <Col lg="11" xl="10" className="text-center">
                            <Box>
                                <Title variant="secSm">
                                    I am looking for new projects. if you'd like
                                    to discuss your project, please get in
                                    touch.
                                </Title>

                                <Box mt="2em" className="text-center">
                                    <ButtonIcon
                                        onClick={e => {
                                            e.preventDefault()
                                            gContext.toggleContact()
                                        }}
                                    >
                                        Let's Talk Now
                                    </ButtonIcon>
                                </Box>
                            </Box>
                        </Col>
                    </Row>
                </Container>
            </SectionStyled>
        </>
    )
}

export default Contact
